import { Quote, TrendingUp, Clock, DollarSign } from "lucide-react";

export default function EnhancedTestimonials() {
  const testimonials = [
    {
      quote: "ArqeraAI didn't just automate our workflows — they transformed how we think about operations. We went from manual chaos to intelligent systems in 90 days.",
      author: "Sarah Chen",
      role: "COO",
      company: "Mid-Market SaaS Company",
      metric: "80% reduction in manual tasks",
      icon: Clock,
    },
    {
      quote: "The strategic audit alone was worth 10x the investment. They showed us AI opportunities we didn't even know existed in our logistics operations.",
      author: "Michael Rodriguez",
      role: "VP of Operations",
      company: "Fortune 500 Logistics Firm",
      metric: "$450K annual savings",
      icon: DollarSign,
    },
    {
      quote: "What sets ArqeraAI apart is their ability to educate our team while building the systems. Now we don't just have AI — we understand it.",
      author: "Jennifer Park",
      role: "Founder & CEO",
      company: "Industrial Services Provider",
      metric: "3x qualified lead growth",
      icon: TrendingUp,
    },
  ];

  return (
    <section className="py-20 md:py-32 px-6 bg-deep-navy relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-96 h-96 bg-cyan rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-bronze rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1 rounded-full border border-cyan/30 bg-cyan/5 mb-6 text-xs text-cyan font-bold uppercase tracking-wider">
            Client Success Stories
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Real Results from Real Partnerships
          </h2>
          <p className="text-lg text-light-gray/80 max-w-3xl mx-auto">
            Strategic transformation backed by measurable outcomes
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="group bg-dark-card rounded-2xl p-8 border border-border/20 hover:border-bronze/40 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-bronze/10"
            >
              {/* Quote Icon */}
              <div className="flex items-start justify-between mb-6">
                <Quote className="w-10 h-10 text-bronze/40 group-hover:text-bronze/60 transition-colors" />
                <testimonial.icon className="w-6 h-6 text-cyan" />
              </div>

              {/* Quote Text */}
              <blockquote className="text-base text-light-gray/90 leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </blockquote>

              {/* Metric Badge */}
              <div className="inline-block px-4 py-2 rounded-full bg-bronze/10 border border-bronze/30 mb-6">
                <p className="text-sm font-semibold text-bronze">
                  {testimonial.metric}
                </p>
              </div>

              {/* Author Info */}
              <div className="border-t border-border/20 pt-4">
                <p className="font-semibold text-foreground mb-1">
                  {testimonial.author}
                </p>
                <p className="text-sm text-medium-gray">
                  {testimonial.role}
                </p>
                <p className="text-xs text-light-gray/60 mt-1">
                  {testimonial.company}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-light-gray/80 mb-4">
            Join the leaders transforming their operations with AI
          </p>
          <a
            href="https://calendly.com/arqeraai-strategy-call/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-bronze font-semibold hover:text-bronze-muted transition-colors group"
          >
            Schedule Your Strategy Audit
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
